import SeeLoLExamResultButton from './SeeLoLExamResultButton';

export default SeeLoLExamResultButton;
